import { render, staticRenderFns } from "./TedsAdministratorLogo.vue?vue&type=template&id=7271a01a&"
import script from "./TedsAdministratorLogo.vue?vue&type=script&lang=ts&"
export * from "./TedsAdministratorLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports